// Montagem do Funil do workflow (Dashboard): por nível N1–N7, as conciliações pendentes com aquele
// nível (barra) e as aprovações registradas por ele (selo). Lógica pura, sem React.

export interface EtapaFunil {
  nivel: number;
  cargo: string;
  /** Conciliações em andamento cujo responsável atual é deste nível (barra do funil). */
  total: number;
  /** Aprovações registradas por usuários deste nível, na empresa e período selecionados. */
  aprovacoes: number;
}

export const NIVEIS_FUNIL = [1, 2, 3, 4, 5, 6, 7] as const;

export const montarFunil = (
  conciliacoes: { responsavelNivel?: number | null }[],
  cargos: { nomeCargo: string; nivelHierarquico: number }[],
  aprovacoesPorNivel: Record<number, number>,
): EtapaFunil[] => {
  const pendentes: Record<number, number> = {};
  conciliacoes.forEach(c => {
    if (c.responsavelNivel) pendentes[c.responsavelNivel] = (pendentes[c.responsavelNivel] || 0) + 1;
  });
  return NIVEIS_FUNIL.map(nivel => ({
    nivel,
    cargo: cargos.find(c => c.nivelHierarquico === nivel)?.nomeCargo ?? `Nível ${nivel}`,
    total: pendentes[nivel] || 0,
    aprovacoes: aprovacoesPorNivel[nivel] || 0, // nível sem aprovação aparece como zero
  }));
};

/** Texto do selo: deixa claro que o número é de aprovações (e acerta o plural; zero é "0 aprovações"). */
export const rotuloAprovacoes = (quantidade: number): string =>
  `${quantidade} ${quantidade === 1 ? 'aprovação' : 'aprovações'}`;

/** Converte a resposta da API ({ niveis: [{ nivel, aprovacoes }] }) em nível → quantidade. */
export const aprovacoesPorNivelDaApi = (niveis: { nivel: number; aprovacoes: number }[] | undefined): Record<number, number> =>
  (niveis ?? []).reduce<Record<number, number>>((acc, n) => ({ ...acc, [n.nivel]: n.aprovacoes }), {});
